import React from 'react';
import GridTaskItem from './GridTaskItem';
import GridGeneralNoteItem from './GridGeneralNoteItem';
import {useTaskAndNotesGridContext} from '../../../../contexts/TaskAndNotesGridContext';
import styles from './styles.module.scss';

export function GridList() {
  const {list} = useTaskAndNotesGridContext()
  const mapTasks = (item, index) => {
    return item.taskID
      ? <GridTaskItem key={index} {...item}/>
      : <GridGeneralNoteItem key={index} {...item}/>;
  };

  return (
    <div className={styles.tasksList}>
      {list
        .sort((a, b) => new Date(b?.createDate) - new Date(a?.createDate))
        .map(mapTasks)
      }
    </div>
  );
}

export default GridList;
